Ext.define('SA.AppControllerStateValue', {
    constructor({controller, mode}) {
        this.controller = controller;
        this.mode = mode;
    },

    getController() {
        return this.controller;
    },

    getMode() {
        return this.mode;
    },

    isViewMode() {
        return this.mode === 'view';
    },

    same(other) {
        return this.sameController(other) && this.sameMode(other);
    },

    sameController(other) {
        return this.getController() === other.getController();
    },

    sameMode(other) {
        return this.getMode() === other.getMode();
    },

    toObject() {
        return {controller: this.getController(), mode: this.getMode()};
    }
});